<template>
  <div class="bd">
    <!-- Touching availabilityOverrides here keeps the list reactive as the location loads. -->
    <span class="hidden">
      {{ location.availabilityOverrides }}
    </span>

    <h1 class="bd-h1">
      Blocked days
    </h1>
    <p class="bd-lead">
      Times you can't host dates: one-off closures and dates that come round every year.
    </p>

    <div class="bd-stack">
      <location-availability-overrides
        v-model="location.availabilityOverrides"
        :location-id="location.id"
      />
      <location-recurring-blocks
        v-model="location.blockedDayPatterns"
        :location-id="location.id"
      />
    </div>
  </div>
</template>

<script>

import LocationAvailabilityOverrides from '@/components/account/LocationAvailabilityOverrides.vue'
import LocationRecurringBlocks from '@/components/account/LocationRecurringBlocks.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    LocationAvailabilityOverrides,
    LocationRecurringBlocks,
  },
  computed: {
    ...mapGetters({
      location: 'authentication/location',
    }),
  },
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

.bd {
  max-width: 1140px;
  margin: 0 auto;
  color: $c-text;
}

.bd-h1 {
  @include ds-page-title;
}

.bd-lead {
  @include ds-lead;
}

.bd-stack {
  @include ds-stack;
}
</style>
